import React from 'react';
import HeroSlider from './HeroSlider';
import '../CSS/home.css';
import bussiness from '../images/home/business.jpg';
import { Link, useNavigate } from 'react-router-dom';
import custom from '../images/home/custom-software.png';
import cloud from '../images/home/cloud.png';
import erp from '../images/home/erp.png';
import maintenance from '../images/home/maintenance.png';
import webapplication from '../images/home/web-application.png';
import windowsapp from '../images/home/windows-app.png';
import database from '../images/home/database.png';
import digital from '../images/home/digital-marketing.png';
import domain from '../images/home/domain-hosting.png';
import frontend from '../images/home/frontend.png';
import mobile from '../images/home/mobile-app.png';
import websitedeve from '../images/home/website-development.png';
import client from '../images/home/Clientfocused.png';
import quality from '../images/home/quality.png';
import partnership from '../images/home/partnership.png';
import timely from '../images/home/timely.png';
import deployment from '../images/home/deployment.png';
import testing from '../images/home/testing.png';
import development from '../images/home/development.png';
import planning from '../images/home/planning.png';
import Requirement from '../images/home/Requirement.png';
import aiVideo from '../images/home/aivideo.png';
import aiImage from '../images/home/aiimages.png';
import aiSolutions from '../images/home/aibussenss.png';



function Home() {
  const navigate = useNavigate();

  return (
    <>
      {/* ================= HERO ================= */}
      <HeroSlider />


      {/* ================= ABOUT / BUSINESS ================= */}
      <section className="business-section">
        <div className="container">

          <div className="home-section-heading text-center">
            <h2>Building Software That Drives Real Business Growth</h2>
          </div>

          <div className="row g-4 align-items-stretch">

            {/* Left Image */}
            <div className="col-lg-6">
              <div className="business-image-card">
                <img
                  src={bussiness}
                  alt="Technology solutions for business"
                />
                <div className="image-overlay">
                  <span>TECHNOLOGY & INNOVATION</span>
                  <h3>Technology That Elevates Your Business</h3>
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6">
              <div className="business-card">
                <h3>Technology That Elevates Your Business</h3>

                <p>
                  We are a technology startup focused on developing innovative,
                  scalable, and user-friendly software solutions. Our mission is
                  to help businesses leverage technology to improve efficiency,
                  automate processes, and achieve sustainable growth.
                </p>

                <div className="business-divider"></div>

                <h3>Solutions Designed for Your Business</h3>

                <p>
                  Whether you're a startup, small business, or growing enterprise,
                  we work closely with you to understand your requirements and
                  deliver solutions that create measurable value.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ================= SERVICES ================= */}
      <section className="services-section">
        <div className="container">

          <div className="section-heading text-center">
            <h2>Business-Driven Technology Solutions Built for Growth</h2>
          </div>

          <div className="row g-4">

            {/* 01 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={custom}
                    alt="Custom software development"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/custom-software" style={{ textDecoration: 'none' }}>    <h3>Custom Software Development</h3></Link>

                  <p>
                    Tailored software solutions designed specifically around
                    your business processes, requirements, and operational needs.
                  </p>
                </div>

              </div>
            </div>


            {/* 02 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={erp}
                    alt="ERP and business management"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/erp-business" style={{ textDecoration: 'none' }}>
                    <h3>ERP & Business Management</h3>
                  </Link>

                  <p>
                    Comprehensive systems for managing inventory, sales,
                    purchases, accounting, customers, and daily operations.
                  </p>
                </div>

              </div>
            </div>


            {/* 03 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={webapplication}
                    alt="Web application development"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/web-application" style={{ textDecoration: 'none' }}>
                    <h3>Web Application Development</h3>
                  </Link>

                  <p>
                    Modern, secure, responsive, and user-friendly web
                    applications built around your business goals.
                  </p>
                </div>

              </div>
            </div>


            {/* 04 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={cloud}
                    alt="Cloud solutions"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/cloud-solutions" style={{ textDecoration: 'none' }}>
                    <h3>Cloud Solutions</h3>
                  </Link>

                  <p>
                    Scalable cloud-based applications that provide
                    accessibility, flexibility, and reliable performance.
                  </p>
                </div>

              </div>
            </div>


            {/* 05 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={maintenance}
                    alt="Software maintenance"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/software-maintenance" style={{ textDecoration: 'none' }}>
                    <h3>Software Maintenance</h3>
                  </Link>
                  <p>
                    Continuous monitoring, updates, improvements, and technical
                    support to keep your software running smoothly.
                  </p>
                </div>

              </div>
            </div>


            {/* 06 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={windowsapp}
                    alt="Windows application development"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/windows-application" style={{ textDecoration: 'none' }}>

                    <h3>Windows Applications</h3>
                  </Link>

                  <p>
                    Small and efficient Windows applications developed for
                    clients to simplify business operations and improve
                    productivity.
                  </p>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ================= AI SOLUTIONS ================= */}
      <section className="ai-solutions-section">
        <div className="container">

          <div className="ai-section-heading text-center ai-section-heading">
           
            <h2>
              AI Solutions For Creativity & Business
            </h2>
          </div>

          <div className="row g-4">

            {/* AI VIDEO */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-service-card">

                <div className="ai-service-image">
                  <img
                    src={aiVideo}
                    alt="AI video creator editor"
                  />

                  <div className="ai-image-overlay">
                    <span>AI VIDEO</span>
                  </div>
                </div>

                <div className="ai-service-content">

                  <div className="ai-icon">
                    🎬
                  </div>

                  <h3>
                    AI Video Creator & Editor
                  </h3>

                  <p>
                    Create engaging videos with AI-powered generation and editing.
                    Turn your ideas, scripts, and images into professional videos
                    quickly and efficiently.
                  </p>

                  <ul>
                    <li>AI Video Generation</li>
                    <li>Text-to-Video</li>
                    <li>AI Video Editing</li>
                    <li>Auto Captions & Subtitles</li>
                    <li>Social Media Videos</li>
                  </ul>

                  <Link
                    to="/ai/video-creator"
                    className="ai-service-button"
                  >
                    Explore AI Video
                    <span>→</span>
                  </Link>

                </div>
              </div>
            </div>


            {/* AI IMAGE */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-service-card">

                <div className="ai-service-image">
                  <img
                    src={aiImage}
                    alt="AI images creator"
                  />

                  <div className="ai-image-overlay">
                    <span>AI IMAGE</span>
                  </div>
                </div>

                <div className="ai-service-content">

                  <div className="ai-icon">
                    🖼️
                  </div>

                  <h3>
                    AI Image Creator
                  </h3>

                  <p>
                    Generate stunning visuals, marketing creatives, product images,
                    and custom artwork using AI-powered image generation and editing.
                  </p>

                  <ul>
                    <li>Text-to-Image</li>
                    <li>AI Image Generation</li>
                    <li>Product Images</li>
                    <li>AI Image Editing</li>
                    <li>Marketing Creatives</li>
                  </ul>

                  <Link
                    to="/ai/image-creator"
                    className="ai-service-button"
                  >
                    Explore AI Images
                    <span>→</span>
                  </Link>

                </div>
              </div>
            </div>


            {/* AI BUSINESS SOLUTIONS */}
            <div className="col-lg-4 col-md-6">
              <div className="ai-service-card">

                <div className="ai-service-image">
                  <img
                    src={aiSolutions}
                    alt="AI business solutions"
                  />

                  <div className="ai-image-overlay">
                    <span>AI SOLUTIONS</span>
                  </div>
                </div>

                <div className="ai-service-content">

                  <div className="ai-icon">
                    🤖
                  </div>

                  <h3>
                    AI Business Solutions
                  </h3>

                  <p>
                    Integrate artificial intelligence into your business to automate
                    repetitive tasks, improve productivity, and deliver smarter
                    customer experiences.
                  </p>

                  <ul>
                    <li>AI Chatbots</li>
                    <li>Business Automation</li>
                    <li>AI Assistants</li>
                    <li>Document Processing</li>
                    <li>Custom AI Integration</li>
                  </ul>

                  <Link
                    to="/ai/business-solutions"
                    className="ai-service-button"
                  >
                    Explore AI Solutions
                    <span>→</span>
                  </Link>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ================= ADDITIONAL DIGITAL SERVICES ================= */}
      <section className="additional-services-section">
        <div className="container">

          <div className="section-heading text-center">

            <h2>Digital Solutions Designed to Accelerate Business Growth</h2>
          </div>

          <div className="row g-4">

            {/* 01 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={websitedeve}
                    alt="Website development"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/website-development" style={{ textDecoration: 'none' }}>
                    <h3>Website Development</h3>
                  </Link>
                  <p>
                    Professional websites developed using WordPress, PHP,
                    .NET, and modern web technologies, designed to be responsive,
                    secure, and aligned with your business requirements.
                  </p>
                </div>

              </div>
            </div>


            {/* 03 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={mobile}
                    alt="Mobile application development"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/mobile-application" style={{ textDecoration: 'none' }}>

                    <h3>Mobile Applications</h3>
                  </Link>
                  <p>
                    Custom mobile applications developed for clients to provide
                    convenient access to their services, products, and business
                    operations.
                  </p>
                </div>

              </div>
            </div>


            {/* 04 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={domain}
                    alt="Domain and hosting"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/domain-hosting" style={{ textDecoration: 'none' }}>
                    <h3>Domain & Hosting</h3>
                  </Link>

                  <p>
                    Domain registration and hosting solutions to help clients
                    establish and maintain a reliable online presence.
                  </p>
                </div>

              </div>
            </div>


            {/* 05 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={digital}
                    alt="Digital marketing and SEO"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/digital-marketing" style={{ textDecoration: 'none' }}>

                    <h3>Digital Marketing & SEO</h3>
                  </Link>
                  <p>
                    Digital marketing solutions using SEO and social media to
                    increase online visibility, reach potential customers, and
                    grow your business.
                  </p>
                </div>

              </div>
            </div>


            {/* 06 */}
            <div className="col-lg-4 col-md-6">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={frontend}
                    alt="Frontend development"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/frontend-development" style={{ textDecoration: 'none' }}>
                    <h3>Frontend Development</h3>
                  </Link>

                  <p>
                    Modern and responsive frontend development using
                    technologies such as Salesforce, React, Angular, and other
                    modern frameworks to create engaging and user-friendly
                    applications.
                  </p>
                </div>

              </div>
            </div>


            {/* 07 */}
            <div className="col-lg-4 col-md-6 mx-auto">
              <div className="service-card">

                <div className="service-image">
                  <img
                    src={database}
                    alt="Database solutions"
                  />
                </div>

                <div className="service-content">
                  <Link to="/services/database-solutions" style={{ textDecoration: 'none' }}>

                    <h3>Database Solutions</h3>
                  </Link>
                  <p>
                    Database design, development, and management using SQL,
                    MongoDB, and other database technologies to support reliable,
                    secure, and scalable applications.
                  </p>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ================= WHY US ================= */}
      <section className="why-section">
        <div className="container">

          <div className="section-heading text-center">
            <h2>Smart Technology Better Business.</h2>
          </div>

          <div className="row g-4">

            <div className="col-lg-3 col-md-6">
              <div className="why-card">

                <div className="why-image">
                  <img
                    src={client}
                    alt="Client focused"
                  />
                </div>

                <div className="why-content">
                  <h3>Client-Focused</h3>

                  <p>
                    We understand your business goals and requirements before
                    developing your solution.
                  </p>
                </div>

              </div>
            </div>


            <div className="col-lg-3 col-md-6">
              <div className="why-card">

                <div className="why-image">
                  <img
                    src={quality}
                    alt="Quality development"
                  />
                </div>

                <div className="why-content">
                  <h3>Quality Development</h3>

                  <p>
                    We build clean, maintainable, secure, and scalable software
                    using modern development practices.
                  </p>
                </div>

              </div>
            </div>


            <div className="col-lg-3 col-md-6">
              <div className="why-card">

                <div className="why-image">
                  <img
                    src={timely}
                    alt="Timely delivery"
                  />
                </div>

                <div className="why-content">
                  <h3>Timely Delivery</h3>

                  <p>
                    Effective planning and development help us deliver projects
                    efficiently and on schedule.
                  </p>
                </div>

              </div>
            </div>


            <div className="col-lg-3 col-md-6">
              <div className="why-card">

                <div className="why-image">
                  <img
                    src={partnership}
                    alt="Long term partnership"
                  />
                </div>

                <div className="why-content">
                  <h3>Long-Term Partnership</h3>

                  <p>
                    We continue to support, maintain, and improve your software
                    as your business grows.
                  </p>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ================= INDUSTRIES ================= */}
      <section className="industry-section">
        <div className="container">

          <div className="section-heading text-center">
            <h2>Solutions For Different Industries</h2>
          </div>

          <div className="row g-4">

            <div className="col-lg-4 col-md-6">
              <div
                className="industry-card"
                style={{
                  backgroundImage:
                    "url('/images/home/manufacturing.png')"
                }}
              >
                <div className="industry-overlay">
                  <Link to='/industries/manufacturing' style={{ textDecoration: 'none', color: '#ffffff' }}>
                    Manufacturing
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                className="industry-card"
                style={{
                  backgroundImage:
                    "url('/images/home/retail.png')"
                }}
              >
                <div className="industry-overlay">
                  <Link to='/industries/retailecommerce' style={{ textDecoration: 'none', color: '#ffffff' }}>
                    Retail & E-commerce</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                className="industry-card"
                style={{
                  backgroundImage:
                    "url('/images/home/healthcare.png')"
                }}
              >
                <div className="industry-overlay">
                  <Link to='/industries/healthcare' style={{ textDecoration: 'none', color: '#ffffff' }}>
                    Healthcare</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                className="industry-card"
                style={{
                  backgroundImage:
                    "url('/images/home/education.png')"
                }}
              >
                <div className="industry-overlay">
                  <Link to='/industries/education' style={{ textDecoration: 'none', color: '#ffffff' }}>
                    Education</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                className="industry-card"
                style={{
                  backgroundImage:
                    "url('/images/home/real-estate.png')"
                }}
              >
                <div className="industry-overlay">
                  <Link to='/industries/realestate' style={{ textDecoration: 'none', color: '#ffffff' }}>
                    Real Estate</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                className="industry-card"
                style={{
                  backgroundImage:
                    "url('/images/home/finance.png')"
                }}
              >
                <div className="industry-overlay">
                  <Link to='/industries/finance' style={{ textDecoration: 'none', color: '#ffffff' }}>
                    Finance & Accounting</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                className="industry-card"
                style={{
                  backgroundImage:
                    "url('/images/home/logistics.png')"
                }}
              >
                <div className="industry-overlay">
                  <Link to='/industries/logistics' style={{ textDecoration: 'none', color: '#ffffff' }}>
                    Logistics & Transportation</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                className="industry-card"
                style={{
                  backgroundImage:
                    "url('/images/home/professional.png')"
                }}
              >
                <div className="industry-overlay">
                  <Link to='/industries/professional' style={{ textDecoration: 'none', color: '#ffffff' }}>
                    Professional Services
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                className="industry-card"
                style={{
                  backgroundImage:
                    "url('/images/home/hospitality.png')"
                }}
              >
                <div className="industry-overlay">
                  <Link to='/industries/hospitality' style={{ textDecoration: 'none', color: '#ffffff' }}>
                    Hospitality
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* ================= PROCESS ================= */}
      <section className="process-section">
        <div className="container">

          <div className="section-heading text-center">
            <h2>Where Ideas Become Solutions</h2>
          </div>

          <div className="row g-4">

            <div className="col-lg col-md-6">
              <div className="process-card">

                <div className="process-image">
                  <img
                    src={Requirement}
                    alt="Requirement analysis"
                  />
                </div>

                <h3>Requirement Analysis</h3>

                <p>
                  We understand your business needs, challenges, and project
                  goals.
                </p>

              </div>
            </div>


            <div className="col-lg col-md-6">
              <div className="process-card">

                <div className="process-image">
                  <img
                    src={planning}
                    alt="Planning and design"
                  />
                </div>

                <h3>Planning & Design</h3>

                <p>
                  We create a clear roadmap and user-focused design for your
                  solution.
                </p>

              </div>
            </div>


            <div className="col-lg col-md-6">
              <div className="process-card">

                <div className="process-image">
                  <img
                    src={development}
                    alt="Software development"
                  />
                </div>

                <h3>Development</h3>

                <p>
                  Our team develops secure, scalable, and reliable software.
                </p>

              </div>
            </div>


            <div className="col-lg col-md-6">
              <div className="process-card">

                <div className="process-image">
                  <img
                    src={testing}
                    alt="Software testing"
                  />
                </div>
                <h3>Testing</h3>

                <p>
                  Comprehensive testing ensures quality, stability, and
                  reliability.
                </p>

              </div>
            </div>


            <div className="col-lg col-md-6">
              <div className="process-card">

                <div className="process-image">
                  <img
                    src={deployment}
                    alt="Deployment and support"
                  />
                </div>
                <h3>Deployment & Support</h3>

                <p>
                  We launch your solution and provide ongoing assistance and
                  improvements.
                </p>

              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ================= CTA ================= */}
      <section className="cta-section">
        <div className="container">

          <div className="cta-box">

            <div className="cta-content">
              <span>LET'S WORK TOGETHER</span>

              <h2>
                Have An Idea?
                <br />
                Let's Turn It Into Reality.
              </h2>

              <p>
                Tell us about your business requirements and let's build a
                software solution that works for you.
              </p>
            </div>
            <button
              className="cta-button"
              onClick={() => navigate('/contactus')}
            >
              Get In Touch
            </button>

          </div>

        </div>
      </section>

    </>
  );
}

export default Home;